import { useQuery } from "@tanstack/react-query";

import { axiosInstanceNamek } from "@/service/Axios";
import { INamekError } from "@/models";

export type MaterialItem = {
  id: number;
  name: string;
};

type CooperativeType = {
  id: number;
  name: string;
  email: string;
};

export type GreenCenterMaterials = {
  id: number;
  name: string;
  cooperative: CooperativeType;
  materials: MaterialItem[];
};

export async function getMaterialsByCVId(greenCenterId: number): Promise<GreenCenterMaterials> {
  const url = `/v1/GreenCenters/${greenCenterId}/Materials`;
  const response = await axiosInstanceNamek.get<GreenCenterMaterials>(url);

  return response.data;
}

export type materialQueryFilters = { greenCenterId?: number };
export const materialQueryKeys = {
  all: ["materials"],
  lists: () => [...materialQueryKeys.all, "list"],
  list: (filters?: materialQueryFilters) => [...materialQueryKeys.lists(), { filters }],
  details: () => [...materialQueryKeys.all, "detail"],
  detail: (id: number) => [...materialQueryKeys.details(), id],
};
export type materialQueryKeyType =
  | string[]
  | number[]
  | (string | { filters?: materialQueryFilters })[];

export function useGetMaterialsByCVId(
  queryKey: materialQueryKeyType = materialQueryKeys.lists(),
  greenCenterId?: number,
) {
  return useQuery<GreenCenterMaterials, INamekError>({
    queryFn: () => getMaterialsByCVId(greenCenterId!),
    queryKey: [...queryKey, { filters: { greenCenterId } }],
    enabled: !!greenCenterId,
    refetchOnMount: true,
  });
}
